export default class UserClaims {
    user = {};
    roles = {};
}